import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import Covid19Page from '../pages/Covid19Page';
import { getUser } from '../selectors/get-user';

const _mapStateToProps = (state, { routeParams: { country, region } }) => {
    const isUserAuthenticated = getUser(state).isAuthenticated;

    return {
        isUserAuthenticated,
        defaultCountrySelected: country,
        defaultRegionSelected: region,
    };
};

const _mapDispatchToProps = {};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(Covid19Page),
);
